import React from "react";
import {observer} from "mobx-react";
import {
    IBookingSearchResultRecordViewModel
} from "../../../../services/agency-booking-search/booking-search-result-record.view-model.interface";
import styled from "styled-components";

import {
    IBookingSearchStrategyViewModel
} from "../../../../services/agency-booking-search/strategies/booking-search.strategy.interface";

import {TableRowComponent} from "./parts/table-row.component";
import {TableHeaderComponent} from "./parts/table-header.component";

const TableBox = styled.div`
    display: grid;
    grid-template-columns: 5rem 3rem 4.5rem auto auto 6.5rem 6.5rem auto 7.5rem 7rem;
    gap: 0;
`


export const BookingSearchResultsTableViewComponent: React.FC<{results: IBookingSearchResultRecordViewModel[];
                                                               currentStrategy: IBookingSearchStrategyViewModel}> = observer((props) => {


    const onRowClick = (recordKey: string) => {
        if(recordKey === props.currentStrategy.selectedRecordKey) {
            props.currentStrategy.selectedRecordKey = null;
        } else {
            props.currentStrategy.selectedRecordKey = recordKey;
        }
    }

    return (
        <TableBox>
            <TableHeaderComponent/>
            {props.results.map(((record, index) => (<TableRowComponent key={record.uniqueKey}
                                                                    record={record}
                                                                    recordIndex={index}
                                                                    currentStrategy={props.currentStrategy}
                                                                    onRowClick={onRowClick}/>)))}
        </TableBox>
    )
})